import { forwardRef } from 'react'

/** One accessible on/off control for rail preferences and modes. */
const RailSwitch = forwardRef<
  HTMLButtonElement,
  {
    label: string
    on: boolean
    onToggle: () => void
    disabled?: boolean
    title?: string
    className?: string
    testId?: string
  }
>(function RailSwitch({ label, on, onToggle, disabled, title, className = '', testId }, ref) {
  return (
    <button
      ref={ref}
      type="button"
      role="switch"
      aria-checked={on}
      className={`rail-switch ${className}${on ? ' on' : ''}`}
      data-testid={testId}
      title={title}
      disabled={disabled}
      onClick={onToggle}
    >
      <span className="et-label">{label}</span>
      <span className="et-switch" aria-hidden="true">
        <span className="et-knob" />
      </span>
    </button>
  )
})
export default RailSwitch
